module.exports = __webpack_public_path__ + "img/4_15.9744cf94.png";